import React, { useState, useEffect } from 'react';

/**
 * Modern fixed-bottom cookie consent banner.
 * Slides up on mount and can be dismissed with "Acceptera" or "Inställningar".
 */
const CookieSnackbar = ({
  cookieConsentGiven,
  setCookieConsentGiven,
  setIsConsentDialogOpen,
  setAnalyticsConsent,
  analyticsConsent,
  openCookieBar,
  setOpenCookieBar,
}) => {
  const [visible, setVisible] = useState(false);

  // Animate in after mount
  useEffect(() => {
    if (cookieConsentGiven === false) {
      const timer = setTimeout(() => setVisible(true), 100);
      return () => clearTimeout(timer);
    }
  }, [cookieConsentGiven]);

  const handleAcceptAll = () => {
    localStorage.setItem('cookieConsentGiven', 'true');
    localStorage.setItem('cookieAnalyticsConsent', analyticsConsent);
    setCookieConsentGiven(true);
    setAnalyticsConsent(analyticsConsent);
    setOpenCookieBar(false);
    setVisible(false);
  };

  const handleSettings = () => {
    setIsConsentDialogOpen(true);
  };

  if (cookieConsentGiven !== false) return null;

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 z-[9999] transition-transform duration-500 ease-out ${
        visible ? 'translate-y-0' : 'translate-y-full'
      }`}
    >
      <div className="bg-brand-dark/95 backdrop-blur-sm border-t border-white/10 px-4 py-5 sm:px-8 sm:py-6">
        <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center gap-4 sm:gap-6">
          {/* Icon + Text */}
          <div className="flex-1 text-center sm:text-left">
            <p className="text-white text-sm sm:text-base leading-relaxed">
              <span className="text-lg mr-2" role="img" aria-label="cookie">
                &#127850;
              </span>
              Postertopia använder cookies och liknande tekniker för att kunna förbättra
              din användarupplevelse. Du kan här välja att acceptera samtliga cookies
              eller anpassa vilka cookies du accepterar eller inte.
            </p>
          </div>

          {/* Buttons */}
          <div className="flex gap-3 flex-shrink-0">
            <button
              onClick={handleSettings}
              className="px-5 py-2.5 text-sm font-medium text-white border border-white/40 rounded-lg
                         hover:bg-white/10 transition-colors duration-200"
            >
              Inställningar
            </button>
            <button
              onClick={handleAcceptAll}
              className="px-6 py-2.5 text-sm font-semibold text-brand-dark bg-white rounded-lg
                         hover:bg-gray-100 transition-colors duration-200"
            >
              Acceptera
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieSnackbar;
